import axiosInstance from "@/utils/axiosConfig";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const roleTypeLogin = createAsyncThunk(
  "employee/login",
  async (credentials, { rejectWithValue }) => {
    try { 
      const response = await axiosInstance.post("/users/auth/switch", credentials);
      const data = response.data;
      console.log(response, "response");
      localStorage.setItem("loginDetails", JSON.stringify(data.data));
      localStorage.setItem("isAuthenticated", true);

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to login"
      );
    }
  }
);

const localStorageData = JSON.parse(localStorage.getItem("loginDetails"));

const initialState = {
  refreshToken: localStorageData?.refreshToken || null,
  token: localStorageData?.token || null,
  userDetails: localStorageData?.userDetails || {
    designation: null,
    empId: null,
    firstName: null,
    idCard: null,
    lastName: null,
    officialEmail: null,
    onboradingStatus: false,
    organizationAccess: [],
    permission: [],
    reportingManager: false,
    reviewer: false,
    roleType: null,
    roles: [],
    spocReportingManagerStatus: false,
    spocStatus: false,
  },
  loading: false,
  error: null,
};

const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.userDetails = action.payload.userDetails;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetEmployee: () => {
      localStorage.removeItem("loginDetails");
      localStorage.removeItem("isAuthenticated");
      return initialState;
    },
  },
});

export const { setAuthData, setLoading, setError, resetEmployee } =
  employeeSlice.actions;

export default employeeSlice.reducer;
